<section class="edit-therapy-wrapper">
  <ng-container
    *ngFor="let form of payload.forms; trackBy: trackByConfig ;let i = index"
    [ngSwitch]="form.type">
    <ng-container *ngSwitchCase="'array'">
      <section [ngClass]="'AUTO_SECTION_' + (form.path | uppercase) ">
        <h3  class="section-title" *ngIf="form.title" (click)="toggleItems(form)">{{form.title}}</h3>
        <section *ngIf="form['showItems'] !== undefined" [ngClass]="{'hidden':!form['showItems']}">
          <section
            *ngFor="let data of getFromPath(form.path); trackBy: trackByItem.bind(this) ;let i = index"
            class="card-layout">
            <gen-dynamic-form
              class="form-wrapper"
              [listenToDataChange]="false"
              [formData]="data"
              [editMode]="true"
              [submitted]="submitted"
              [formName]="form.formId"
              [updatedFieldsContext]="payload.therapy.id+','+ getItemId(data)"
              [updatedFieldsContextType]="'TherapyMatch,InternalClientID'"
              (formChange)="updateTherapy($event.form,form.path, i)"
            ></gen-dynamic-form>
            <section
            class="button-wrapper"
            >
            <gen-button
              class="icon"
              [type]="'quite'" (click)="removeItem(getFromPath(form.path), i)" [iconClass]="'fa fa-trash'"></gen-button>
            </section>
          </section>
          <gen-button
            class="append-button"
            [type]="'secondary'" (click)="addItem(form.path)" [text]="'Add item'"></gen-button>
        </section>
      </section>
    </ng-container>

    <ng-container *ngSwitchDefault >
      <h3  class="section-title" *ngIf="form.title">{{form.title}}</h3>
      <gen-dynamic-form
        [ngClass]="'AUTO_SECTION_THERAPY'"
        [listenToDataChange]="true"
        [formData]="getFromPath(form.path)"
        [editMode]="true"
        [formName]="form.formId"
        [submitted]="submitted"
        [updatedFieldsContext]="payload.therapy.id"
        [updatedFieldsContextType]="'TherapyMatch'"
        (formChange)="updateTherapy($event.form,form.path)"
      ></gen-dynamic-form>
    </ng-container>

  </ng-container>
</section>
